<template>
  <div class="finance-detail-page page-padding-top">
    <top-bar :title="i18n.t(`finance.title4`)" @back="back" ></top-bar>
    <div class="position-list">
      <div class="list big" >
        <div class="flex-center-between name">
          <div class="flex-center">
            <img :src="`/upload/${detailData.FinancialSetup.Currency.Logo}`" alt="">
            <span>{{detailData.FinancialSetup.Currency.Name}}</span>
          </div>
          <div class="tag">
            {{detailData.FinancialSetup.ProductType === 1 ? $t('finance.label13') : $t('finance.label14')}}
          </div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label12')}}</div>
          <div class="count" :class="detailData.Status == 1 ? 'red' : 'green'">{{$t(`finance.tab${detailData.Status == 0 ? 3 : detailData.Status == 1 ? 5 : 4}`)}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label10')}}</div>
          <div class="count">{{detailData.FinancialSetup.IncomeRatio}}%</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label9')}}</div>
          <div class="count">{{parseFloat(detailData.OrderAmount).toFixed(2)}} USDT</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label19')}}</div>
          <div class="count">{{parseFloat(detailData.IncomeAmount).toFixed(2)}} USDT</div>
        </div>

        <div class="space"></div>

        <div class="line-title">{{$t('finance.label20')}}</div>
        <div class="flex-center-between line" v-for="(item, i) in logList" :key="i">
          <div class="label">{{item.CreatedAt.substring(5, 10)}}</div>
          <div class="count">{{item.IncomeAmount}}</div>
        </div>
        <!-- <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label15')}}</div>
          <div class="count">{{detailData.CreatedAt}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label17')}}</div>
          <div class="count">{{detailData.InterestDate}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label18')}}</div>
          <div class="count">{{getEndDate(detailData)}}</div>
        </div> -->
       
      </div>
    </div>

    <div class="bottom-fixed-btn" v-if="detailData.FinancialSetup.ProductType === 1">
      <Button class="btn" @click="toWithdraw">{{$t('finance.btn2')}}</Button>
    </div>
  </div>
</template>
<script>
import { Button, List } from 'vant'
import topBar from '@/components/topBar'
import { financeWithdraw } from '@/api/finance'
import moment from 'moment'
export default {
  components: {
    topBar,
    Button,
    List
  },
  data() {
    return {
      rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      bitUrl: require('../../assets/imgs/bit1.png'),
      detailData: {
        FinancialSetup: {
          Currency: {}
        }
      },
      pageType: 1,
      logList: []
    }
  },
  mounted() {
    this.pageType = parseInt(this.$route.query.type)
    let data = sessionStorage.getItem('financeData')
    if (data) {
      this.detailData = JSON.parse(data)
      this.logList = this.detailData.FinancialRecord || []
    }
  },
  methods: {
     back() {
      this.$router.go(-1)
    },
    getEndDate(data) {
      if (data.InterestDate && data.FinancialSetup) {
        if (data.FinancialSetup.ProductType === 1) {
          return moment(data.InterestDate).add(parseInt(data.FinancialSetup.Term), 'days').format('YYYY-MM-DD')
        } else {
          return this.$t('finance.label14')
        }
      }
    },
    toWithdraw() {
      let form = new FormData()
      form.append('ID', this.detailData.ID)
      financeWithdraw(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.$t('finance.success'))
          setTimeout(() => {
            this.back()
          }, 1500)
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>